/**
 * Helpers para abrir Blobs PDF en nueva pestaña.
 *
 * Usamos SOLO un anchor con target="_blank" — no window.open + fallback.
 * Motivo (fix dev68): `window.open(url, "_blank", "noopener,noreferrer")`
 * retorna `null` por spec en varios browsers cuando se usa `noopener`,
 * aunque la ventana SÍ se abra. El fallback detectaba ese null y disparaba
 * el anchor → resultado: DOS pestañas abiertas. El anchor solo funciona
 * consistente en todos los browsers modernos.
 */
export function openBlobInNewTab(blob: Blob): void {
  const pdfBlob =
    blob.type === "application/pdf"
      ? blob
      : new Blob([blob], { type: "application/pdf" });
  const url = URL.createObjectURL(pdfBlob);
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  // Necesario para Firefox y algunos contextos: el anchor debe estar
  // en el DOM antes de `click()`.
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revocar después de un rato — si el navegador tarda en abrir, no
  // queremos invalidar la URL antes de tiempo.
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
